<template>
  <div
    v-if="curation && curation.permission && curation.edit"
    class="jps-curation-footer"
    :class="{
      'page-jps': isJps,
      'page-hina': isHina,
    }"
  >
    <BaseSectionContainer
      tag="div"
      size="middle"
    >
      <CurationSubpagePager :curation="curation" />
      <dl class="jps-credit is-size-7 generated-7">
        <dt class="jps-section-heading heading-page-metadata">{{ lss('責任表示', 'Responsibility') }}</dt>
        <dd>
          <span
            v-if="!isEmpty(curation.responsibility)"
            class="jps-curation-responsibility"
          >
            {{ ls(curation.responsibility) }}
          </span>
          <UiOrgSpan
            v-else-if="curation.permission.ownerOrg"
            :id="curation.permission.ownerOrg"
          />
        </dd>
        <dt class="jps-section-heading heading-page-metadata">{{ lss('二次利用について', 'Secondary Usage') }}</dt>
        <dd>
          <UiRightsTag
            v-if="curation.rightsType"
            :rights="curation.rightsType"
            :rights-description="curation.rights"
          />
        </dd>
        <dd>
          <p
            class="jps-curation-modal-rights-info"
            v-shtml="ls(curation.rights)"
          />
        </dd>
        <dt class="jps-section-heading heading-page-metadata">{{ ls(dapLangGlobal.lastUpdated) }}</dt>
        <dd>{{ ldate(curation.edit.date) }}</dd>
      </dl>
    </BaseSectionContainer>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import vShtml from '~/directives/shtml'

const { ls, lss, ldate } = useI18n()
const { isJps, isHina } = useServiceType()

interface Props {
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-footer {
  background-color: #f8f9f9;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
  .jps-credit {
    dt {
      margin-top: 1.5rem;
    }
    dd {
      margin-bottom: 0.5rem;
    }
    .jps-curation-responsibility {
    }
    .tag {
      margin: 0.5rem 0 0 0;
      padding: 0.25rem 1rem;
      border-radius: 1rem;
    }
  }
  .jps-curation-footer-org {
    margin-top: 3rem;
    h1 {
      margin: 1rem;
    }
  }
  .jps-curation-foot-attr {
    text-align: center;
    font-size: 0.875rem;
  }
}

.generated-7 {
    text-align: center;
}

.page-hina {
  .jps-credit {
    dt {
      margin-top: 2.5rem;

      &:first-child {
        margin-top: 1rem;
      }

      & + * {
        margin-top: 1rem;
      }
    }
  }
}
</style>
